<template>
<div :style="columnMargin" class="four-classify position-relative">
  <img v-if="item.bgImg" class="ajax-cover-bg" :src='item.bgImg' />
  <div class="classify-area flex-1">
    <div @click="doLocationHref(classifyItem)" v-for="(classifyItem, classifyIndex) in item.classifyList" :key="classifyIndex" class="classify-one">
      <div v-if='classifyIndex == item.classifyList.length - 1' class="line"></div>
      <img class="classify-img" :src="classifyItem.imgUrl" />
      <div>{{classifyItem.adName}}</div>
    </div>
  </div>
  <!-- <div v-if='item.classifyAll.length' class="line"></div> -->
  <!-- <div @click="doLocationHref(item.classifyAll[0])" v-if='item.classifyAll.length' class="all-classify">
    <img class="all-classify-img" :src="item.classifyAll[0].imgUrl" />
    <div>{{item.classifyAll[0].adName}}</div>
    <div class="check-more-classify">查看更多</div>
  </div> -->
</div>
</template>

<script>
export default { 
  name: 'FourClassify',
  data() {
    return {
      active: 0,
    }
  },
  props: {
    item: Object,
  },
  components: {
  },
  created() {
  },
  mounted() {
  },
  watch: {
  },
  computed: {
    columnMargin(){
      var obj = {}
      if(this.item.marginObj){
        obj={
          'margin-top': this.item.marginObj.top,
          'margin-bottom': this.item.marginObj.bottom
        }
      }
			return obj
    }
  },
  methods: {
    doLocationHref(obj){
      var self = this
      this.$store.commit('doTrack',{
        href: obj.adHrefUrl,
        columnDefineId: self.item.columnDefineId,
        ccId: obj.ccId,
        adId: obj.adId,
        adName: obj.adName,
        idType: 'adId'
      });
      window.location.href = obj.adHrefUrl
    },
  }
}
</script>

<style scoped>
.four-classify{
  margin-top: 10px;
  margin-left: 15px;
  width: 345px;
  height: 88px;
  color: #333;
  font-size: 12px;
  /* background: #FFFFFF; */
  border-radius: 10px;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.flex-1{
  flex: 1
}
.line{
  width: 1px;
  height: 27px;
  background: #E8E8E8;
  position: absolute;
  left: 0;
}
.classify-area{
  display: flex;
  justify-content: space-around
}
.classify-one{
  width: 68px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative
}
.classify-img{
  width: 50px;
  height: 50px;
  object-fit: contain;
  display: block;
  margin-bottom: 2px
}
.all-classify{
  width: 71px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.all-classify-img{
  width: 30px;
  height: 30px;
  display: block;
  border-radius: 50%;
  margin-bottom: 5px
}
.check-more-classify{
  font-size: 10px;
  color: #666666;
  margin-top: 1px;
  background: url(/public/images/mobile/icon_arrows_r.png) no-repeat right center;
  background-size: 7px;
  padding-right: 9px
}
</style>